module.exports = __webpack_public_path__ + "static/media/di32kz.5fc094ce.pdf";